/* eslint-disable */
import { Component } from 'react';
import { Table, Menu, Icon } from 'semantic-ui-react'
import { connect } from 'react-redux';
import { getAllGuias, postGuias } from '@store/actions/index';
import _ from 'lodash';
import m from '@utils/strings';
import { getTodayDate, reverseMaskDate } from "@utils/date";
import AjaxLoader from '@components/shared/ajax_loader';

class TableGuias extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tableRows: [],
            column: null,
            direction: null,
            data: [],
            actualPage: 1,
            amountPages: 1,
            lastRequestWasFiltered: false,
            lastParamsValues: {},
            showLoader: false
        }
    }

    componentDidMount() {
        this.props.applyFilterTable(this.applyFilterTable);
        this.props.updateApplyingFilter(this.updateApplyingFilter);
    }

    mapTableRowJSX = (list) => {
        return list.map(
            (guia) => {
                let isTipoSPSADT = guia.Senha ? true : false;
                let date = isTipoSPSADT ? guia.Atendimento.Dataatendimento.split('-') : guia.DataAtendimento.split('-');
                let day = date[2].split('T')[0];
                let month = date[1];
                let year = date[0];

                return (
                    <Table.Row key={isTipoSPSADT ? `1${guia.Id}` : `2${guia.Id}`}>
                        <Table.Cell>
                            <div className='td-guia-left-align'>
                                {isTipoSPSADT ? guia.NumeroGuiaOperadora : guia.NumeroGuiaPrestador}
                            </div>
                        </Table.Cell>
                        <Table.Cell>
                            <div className='td-guia-left-align'>
                                {isTipoSPSADT ? guia.Atendimento.CarteiraBeneficiario : guia.NumeroCarteiraBeneficiario}
                            </div>
                        </Table.Cell>
                        <Table.Cell>
                            <div className='td-guia-left-align'>
                                {isTipoSPSADT ? guia.Atendimento.Nomebeneficiario : guia.NomeBeneficiario}
                            </div>
                        </Table.Cell>
                        <Table.Cell>
                            <div className='td-guia-left-align'>
                                {`${day}/${month}/${year}`}
                            </div>
                        </Table.Cell>
                        <Table.Cell>
                            <div className='td-guia-left-align'>
                                {isTipoSPSADT ?
                                    (guia.NomeSolicitante == 'PLANTONISTA' ?
                                        m.TELA_REIMPRESSAO_GUIA.LABEL_TIPO_ATENDIMENTO_TABELA_CONSULTA_PS
                                        : guia.CaraterAtendimento == 1 && guia.CaraterAtendimento == '1' ?
                                            m.TELA_REIMPRESSAO_GUIA.LABEL_TIPO_ATENDIMENTO_TABELA_EXAMES_PROCEDIMENTOS_ELETIVOS
                                            : guia.CaraterAtendimento == 2 || guia.CaraterAtendimento == '2' ?
                                                m.TELA_REIMPRESSAO_GUIA.LABEL_TIPO_ATENDIMENTO_TABELA_EXAMES_PROCEDIMENTOS_PS
                                                    : '')
                                        
                                    : m.TELA_REIMPRESSAO_GUIA.LABEL_TIPO_ATENDIMENTO_TABELA_CONSULTA_ELETIVA}
                            </div>
                        </Table.Cell>
                        <Table.Cell>
                            <div className='td-guia-center-align'>
                                <img
                                    src="../images/green_print.png"
                                    alt="print"
                                    style={{ cursor: 'pointer' }}
                                    onClick={(a) => {
                                        isTipoSPSADT ? this.props.getGuia(guia.Senha, guia.NumeroGuiaOperadora)
                                            : this.props.getGuiaConsulta(guia.Id);
                                    }} />
                            </div>
                        </Table.Cell>
                    </Table.Row>
                );
            }
        );
    }

    loadTableRows = (params) => {
        if(null == params)
            params = {};

        let mapSuccessFunction = (result) => {

            if((result?.data?.ListaGuias ?? []).length == 0)
                this.props.callSnackbar(m.TELA_REIMPRESSAO_GUIA.NOTIFICACAO_SUCESSO_RETORNO_VAZIO, 'success');

            let tableRows = this.mapTableRowJSX(result && result.data ? result.data.ListaGuias : []);

            this.setState({
                tableRows: tableRows,
                amountPages: result && result.data ? result.data.QuantidadePaginas : 1,
                data: result && result.data ? result.data.ListaGuias : [],
                showLoader: false
            });
        }

        let mapErrorFunction = (error) => {
            this.props.callSnackbar(m.TELA_REIMPRESSAO_GUIA.NOTIFICACAO_ERRO_SERVIDOR, 'error');
            this.setState({ showLoader: false });
        }

        params.filtrarAPartirDe = this.state.actualPage;
        params.idPrestador = this.props.prestador.Id;

        if(null == params.periodoInicial)
            params.periodoInicial = reverseMaskDate(getTodayDate());

        if(null == params.periodoFinal)
            params.periodoFinal = reverseMaskDate(getTodayDate());

        this.props.postGuias(params, mapSuccessFunction, mapErrorFunction);
    }

    applyFilterTable = (params) => {
        this.setState({
            actualPage: 1,
            showLoader: true
        }, () => {
            if (params)
                this.updateApplyingFilter(params);
            else
                this.updateTableRows();
        });
    }

    updateApplyingFilter = (params) => {
        this.setState({
            lastRequestWasFiltered: true,
            showLoader: true
        });

        if (params) {
            this.setState({ lastParamsValues: params });
            this.loadTableRows(params);
        } else if (!_.isEmpty(this.state.lastParamsValues)) {
            this.loadTableRows(this.state.lastParamsValues);
        }
    }

    updateTableRows = () => {
        this.setState({
            lastRequestWasFiltered: false,
            showLoader: true
        });

        this.loadTableRows();
    }

    handleSort = (clickedColumn, willReverse) => {
        let { column, direction, tableRows, data } = this.state;
        if (column !== clickedColumn) {
            if (clickedColumn === 'nomebeneficiario')
                this.setState({
                    column: clickedColumn,
                    tableRows: this.mapTableRowJSX(_.sortBy(data, ['atendimento.nomebeneficiario'])),
                    direction: 'ascending',
                });
            else if (clickedColumn === 'dataatendimento')
                this.setState({
                    column: clickedColumn,
                    tableRows: this.mapTableRowJSX(_.sortBy(data, ['atendimento.dataatendimento'])),
                    direction: 'ascending',
                });
            else
                this.setState({
                    column: clickedColumn,
                    tableRows: this.mapTableRowJSX(_.sortBy(data, [clickedColumn])),
                    direction: 'ascending',
                });
            return
        }

        if (willReverse === 'dontreverse')
            this.setState({
                direction: 'descending'
            });
        else
            this.setState({
                tableRows: tableRows.reverse(),
                direction: direction === 'ascending' ? 'descending' : 'ascending'
            });
    }

    render() {
        let { column, direction, actualPage, amountPages, showLoader } = this.state;

        const prestadorLoader = showLoader ? <AjaxLoader ajaxMessage={m.TELA_REIMPRESSAO_GUIA.MENSAGEM_LOADER_BUSCANDO_PRESTADOR} /> : "";

        return (
            <div className='wrapper'>
                {prestadorLoader}
                <div className='layout-table-guias-body'>
                    <Table striped sortable>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell
                                    sorted={column === 'numeroGuiaOperadora' ? direction : null}
                                    onClick={() => { this.handleSort('numeroGuiaOperadora') }} >
                                    {m.TELA_REIMPRESSAO_GUIA.LABEL_NUMERO_GUIA}
                                </Table.HeaderCell>
                                <Table.HeaderCell
                                    sorted={column === 'numeroCarteira' ? direction : null}
                                    onClick={() => { this.handleSort('numeroCarteira') }}>
                                    {m.TELA_REIMPRESSAO_GUIA.LABEL_NUMERO_CARTEIRA}
                                </Table.HeaderCell>
                                <Table.HeaderCell
                                    sorted={column === 'nomebeneficiario' ? direction : null}
                                    onClick={() => { this.handleSort('nomebeneficiario') }}>
                                    {m.TELA_REIMPRESSAO_GUIA.LABEL_BENEFICIARIO}
                                </Table.HeaderCell>
                                <Table.HeaderCell
                                    sorted={column === 'dataatendimento' ? direction : null}
                                    onClick={() => { this.handleSort('dataatendimento') }}>
                                    {m.TELA_REIMPRESSAO_GUIA.LABEL_DATA_ATENDIMENTO}
                                </Table.HeaderCell>
                                <Table.HeaderCell
                                    sorted={column === 'caraterAtendimento' ? direction : null}
                                    onClick={() => { this.handleSort('caraterAtendimento') }}>
                                    {m.TELA_REIMPRESSAO_GUIA.LABEL_TIPO_ATENDIMENTO}
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    {m.TELA_REIMPRESSAO_GUIA.LABEL_REIMPRIMIR_GUIA}
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {this.state.tableRows}
                        </Table.Body>
                    </Table>
                </div>
                <div className='table-header-footer'>
                    <div className='layout-pagination-div'>
                        <Menu pagination>
                            <Menu.Item as='a' icon
                                onClick={() => {
                                    this.setState({ actualPage: actualPage > 1 ? actualPage - 1 : 1 }
                                        , this.state.lastRequestWasFiltered ? this.updateApplyingFilter : this.updateTableRows);
                                }}
                            >
                                <Icon name='chevron left' />
                            </Menu.Item>
                            <Menu.Item>
                                Página {actualPage} de {amountPages}
                            </Menu.Item>
                            <Menu.Item as='a' icon
                                onClick={() => {
                                    this.setState({ actualPage: actualPage < amountPages ? actualPage + 1 : amountPages }
                                        , this.state.lastRequestWasFiltered ? this.updateApplyingFilter : this.updateTableRows);
                                }}
                            >
                                <Icon name='chevron right' />
                            </Menu.Item>
                        </Menu>
                    </div>
                </div>
                <div className='div-separador-50' />
            </div>
        );
    }
}

export default connect(null, { getAllGuias, postGuias })(TableGuias);
